import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=bbb671b8&scoped=true&"
import script from "./popup.vue?vue&type=script&lang=ts&"
export * from "./popup.vue?vue&type=script&lang=ts&"
import style0 from "./popup.vue?vue&type=style&index=0&id=bbb671b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb671b8",
  null
  
)

export default component.exports